import React, { useEffect, useState } from "react";
import "./User.css";
import { useNavigate } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { db } from '../firebase';
import { doc, getDoc, updateDoc } from "firebase/firestore";

const OtherStaff = () => {
  const [openPinDialog, setOpenPinDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [pin, setPin] = useState(""); // Store input value
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/")
    }
  }, [])


  const handlePinInputChange = (e) => {
    setPin(e.target.value);
  };

  const handleOpenPinDialog = () => {
    setOpenPinDialog(true);
  };

  const handleClosePinDialog = () => {
    setOpenPinDialog(false);
    setPin(""); // Clear input field
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
  };

  const handleUpdatePin = async () => {
    const empId = localStorage.getItem("empid");
    if (!empId) {
      alert("Employee ID not found in localStorage!");
      return;
    }

    const docRef = doc(db, "empmaster", empId);
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        // Update the Firestore document with new pin
        await updateDoc(docRef, { pin: pin });
        setOpenPinDialog(false);
        setOpenSuccessDialog(true);
      } else {
        alert("User not found!");
      }
    } catch (error) {
      console.error("Error updating PIN:", error);
      alert("Failed to update PIN.");
    }
  };
  const handleLogout = (e) => {
    e.preventDefault();
    sessionStorage.setItem("login", false)
    window.location.replace("/")
  }

  return (
    <div className="user-container">
      {/* PIN Update Dialog */}
      <Dialog open={openPinDialog} onClose={handleClosePinDialog}>
        <DialogTitle>Enter New PIN:</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="adminpin"
            label="New PIN"
            type="number"
            fullWidth
            variant="standard"
            value={pin}
            onChange={handlePinInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePinDialog}>Cancel</Button>
          <Button onClick={handleUpdatePin}>Update</Button>
        </DialogActions>
      </Dialog>

      {/* Success Dialog */}
      <Dialog open={openSuccessDialog} onClose={handleSuccessDialogClose}>
        <DialogTitle>PIN Updated Successfully!</DialogTitle>
        <DialogActions>
          <Button onClick={handleSuccessDialogClose}>OK</Button>
        </DialogActions>
      </Dialog>

      <h1 className="welcome">Welcome {localStorage.getItem("empname") || "User"}</h1>
      <br /><br />
      <div className="icon-grid">
        <div className="icon-box">
          <img src="/assets/notesheet2.png" alt="Settings" className="icon" onClick={() => navigate('/generalnotesheet')} />
        </div>
        <div className="icon-box">
          <img src="/assets/notesheet.png" alt="Settings" className="icon" onClick={() => navigate('/notesheetdownload2')} />
        </div>
        <div className="icon-box">
          <img src="/assets/reporting.png" alt="Tasks" className="icon" onClick={() => navigate('/reporting')} />
        </div>
        <div className="icon-box">
          <img src="/assets/leaveapplication2.png" alt="Tasks" className="icon" onClick={() => navigate('/leaveapplication')} />
        </div>
        <div className="icon-box">
          <img src="/assets/PIN.png" alt="Settings" className="icon" onClick={handleOpenPinDialog} />
        </div>
      </div><br /><br />
      <center>
        <img src="/assets/logout.png" style={{ height: '120px' }} alt="" onClick={handleLogout} />
      </center>
    </div>
  );
};

export default OtherStaff;
